/**
 * DEMANDAS: AS REGRAS DA ESCRITA (11/10/2026, medição da DemandasTab). Funções puras que a tela usa e os testes cobram
 * dos dois lados.
 */

/** Os tipos e o limite que o backend aceita (demandas.service addAttachment). O seletor era `image/*`, que inclui HEIC e SVG. */
export const TIPOS_DE_ANEXO = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'application/pdf'];
export const ACEITA_NO_SELETOR = TIPOS_DE_ANEXO.join(',');
export const LIMITE_DO_ANEXO = 10 * 1024 * 1024;

/**
 * D1: conferido ANTES de salvar. Era o caminho da demanda duplicada: o servidor recusava o anexo depois de criar a
 * demanda, a tela dizia "Erro ao salvar" com o form preenchido, e o segundo clique criava outra.
 */
export function porqueRecusarArquivo(f: { name?: string; type?: string; size?: number }): string | null {
  if (!TIPOS_DE_ANEXO.includes(String(f?.type || ''))) {
    return `${f?.name || 'O arquivo'} não vai: o servidor aceita só PNG, JPG, GIF, WebP e PDF.`;
  }
  if ((f?.size || 0) > LIMITE_DO_ANEXO) {
    return `${f?.name || 'O arquivo'} não vai: tem ${((f.size as number) / 1024 / 1024).toFixed(1)} MB, e o limite é 10 MB.`;
  }
  return null;
}

export type Falha = { filename: string; motivo: string };

/** D1: a demanda foi criada e um anexo não subiu. A tela abre a demanda e deixa o que faltou pendente para anexar ali. */
export function avisoDaCriacaoComFalha(code: string, falhas: Falha[]): string {
  const nomes = falhas.map((f) => `${f.filename} (${f.motivo})`).join('; ');
  return `${code} criada. Não consegui anexar ${nomes}: ${falhas.length === 1 ? 'ele ficou pendente' : 'eles ficaram pendentes'} no comentário da demanda; envie dali. Não crie a demanda de novo.`;
}

/** D2: o comentário saiu e um anexo não. O texto sai do campo; só o que faltou fica. */
export function avisoDoComentarioComFalha(falhas: Falha[]): string {
  return `Comentário enviado. Não consegui anexar ${falhas.map((f) => `${f.filename} (${f.motivo})`).join('; ')}: ficou no campo para enviar de novo.`;
}

/** D4: o form não escolhe responsável; o servidor aplica o padrão da equipe (env). Até ele expor quem é, a frase é genérica. */
export const FRASE_DO_RESPONSAVEL = 'Vai para o responsável padrão da equipe. Dá para trocar no detalhe, depois de criar.';

/** D5: Descartar é o único status que tira a demanda da fila. */
export function confirmacaoDeDescartar(d: { code: string; title?: string }) {
  return {
    title: 'Descartar a demanda?',
    message: `${d.code}${d.title ? ` - ${d.title}` : ''}.`,
    consequence: 'Sai da fila e das métricas de abertas; dá para reabrir depois.',
    confirmLabel: 'Descartar',
  };
}

export function confirmacaoDeRemoverAnexo(a: { originalName?: string }): string {
  return ['Remover o anexo?', `${a?.originalName || 'Este anexo'}: o arquivo é apagado do armazenamento, sem volta.`].join('\n\n');
}

/** D3: o deep-link que não acha diz por quê. */
export function avisoDoLinkSemDemanda(code: string, listaCarregou: boolean): string {
  return listaCarregou
    ? `${code} não encontrada: pode ter sido excluída, ou o código está errado.`
    : `Não abri ${code}: a lista de demandas não carregou.`;
}
